<template>
  <div>
    <Card>
      <Row>
        <Button type="info"
                @click="add">{{$t('pages_banners_index_178')}}</Button>{{$t('pages_customer_level_index_293')}}<i-switch v-model="setting.customer_level_auto_upgrade"
                          size="large"
                          @on-change="change_customer_level_auto_upgrade">
                  <span slot="open">{{$t('pages_customer_level_index_294')}}</span>
                  <span slot="close">{{$t('pages_birthday_discount_index_209')}}</span>
                </i-switch>
      </Row>
      <TablePaginate :columns="columns"
                     :data="customer_levels"
                     :loading="loading"
                     :meta="meta"
                     :changePage="changePage"></TablePaginate>
    </Card>
    <Modal v-model="modalShow"
           @on-ok="handleSubmit"
           :title="$t('pages_customer_level_index_295')">
      <Form ref="category"
            :model="customer_level"
            :label-width="80">
        <Form-item :label="$t('pages_customer_level_index_296')"
                   prop="name">
          <Input type="text"
                 v-model="customer_level.name" />
        </Form-item>
        <Form-item :label="$t('pages_customer_level_index_297')"
                   prop="discount">
          <Input type="number"
                 v-model="customer_level.discount" />
        </Form-item>
        <Form-item :label="$t('pages_customer_level_index_298')"
                   prop="upgrade_standard">
          <Input type="number"
                 v-model="customer_level.upgrade_standard" />
        </Form-item>
        <Form-item :label="$t('pages_customer_level_index_299')">
          <span style="color: red;">{{$t('pages_customer_level_index_300')}}</span>
        </Form-item>
      </Form>
    </Modal>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import { deleteButtonInTable, editorButtonInTable } from '@/libs/table-render'

export default {
  components: {
    TablePaginate,
  },
  data () {
    return {
      modalShow: false,
      formType: '',
      columns: [
        {
          title: i18n.t('pages_customer_level_index_301'),
          key: 'name'
        },
        {
          title: i18n.t('pages_customer_level_index_302'),
          key: 'discount'
        },
        {
          title: i18n.t('pages_customer_level_index_298'),
          key: 'upgrade_standard'
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 200,
          align: 'center',
          render: (h, params) => {
            const children = []
            children.push(deleteButtonInTable(this, h, params))
            children.push(editorButtonInTable(this, h, params))
            return h('div', children)
          }
        }
      ]
    }
  },
  created () {
    this.changeQuery({ page: 1 })
    this.index()
    this.display()
  },
  computed: {
    ...mapGetters('setting', ['setting']),
    ...mapState('customer_level', ['customer_level', 'customer_levels', 'meta', 'loading'])
  },
  methods: {
    ...mapActions('customer_level', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy'
    ]),
    ...mapActions('setting', ['display', 'upgrade']),

    ...mapMutations('customer_level', ['changeQuery']),
    changePage (page) {
      this.changeQuery({ page: page })
      this.index()
    },
    add () {
      this.clear()
      this.modalShow = true
      this.formType = 'new'
    },
    uploadedUrl (url) {
      this.customer_level.image = url
    },
    async handleSubmit () {
      if (this.formType === 'edit') {
        await this.update(this.customer_level)
      } else if (this.formType === 'new') {
        await this.create(this.customer_level)
      }
      this.modalShow = false
    },
    change_customer_level_auto_upgrade () {
      this.upgrade({ customer_level_auto_upgrade: this.setting.customer_level_auto_upgrade })
    },
  }
}
</script>
